<template>
  <div class="cp-navigation" >
    <!-- <div class="cp-navigation-header has-background-primary">
      <div class="cp-navigation-header-container">
        <div class="cp-navigation-contract">
          <p class="cp-navigation-telephone has-text-black">
            {{ $t('navigation.tel') }}: {{ contact.phone_number }}
            {{ $t('navigation.tel') }}: +668000000
          </p>
          <p class="cp-navigation-telephone has-text-black">
            E-mail : madamranee@gmail.com
          </p>
          <span>
            <a
              class="cp-navigation-icon has-text-black"
              :href="contact.facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-icon pack="fab" icon="facebook-square" size="is-medium" type="is_black"></b-icon>
            </a>
            <a
              class="cp-navigation-icon has-text-black"
              :href="`http://line.me/ti/p/~${contact.line_id}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-icon pack="fab" icon="line" size="is-medium"></b-icon>
            </a>
            <a
              class="cp-navigation-icon has-text-black"
              :href="`http://line.me/ti/p/~${contact.line_id}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-icon pack="fab" icon="twitter" size="is-medium"></b-icon>
            </a>
            <a
              class="cp-navigation-icon has-text-black"
              :href="`mailto:${contact.email}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-icon
                class="cp-navigation-icon"
                pack="fas"
                icon="envelope-square"
                size="is-medium"
              ></b-icon>
            </a>
          </span>
          <span>
            <a class="has-text-white" @click="updateLocale('th_TH')">TH </a>
            |
            <a class="has-text-white" @click="updateLocale('en_US')"> EN</a>
          </span>
        </div>
      </div>
    </div> -->
  <fixed-header>
    <div class="navbar cp-navigation-body bg-black">
      <div class="cp-navigation-body-container">
        <b-icon
          class="cp-navigation-burger has-text-primary"
          pack="fas"
          icon="bars"
          size="is-medium"
          @click.native="$emit('toggle-drawer')"
        ></b-icon>
        <router-link to="/" class="md-home-logo">
           <img :src="company.logo_image" @click="gotoHome()">
        </router-link>
        <!-- <router-link
            to="/order"
            >
            <div class="md-home-cart is-hidden-desktop">
              <img src="../assets/img/home/logo-cart.png" class="">
              <span class="md-cart-amount">{{productCart.length}}</span>
            </div>
        </router-link> -->
        <div class="cp-navigation-page-link">
          <router-link
            :class="{
              'has-text-white': true,
              'cp-navigation-page-link-item': true,
            }"
            to="/"
            exact
            >{{ $t('navigation.home') }}</router-link
          >
          <!-- <b-navbar-dropdown label="Product"
            :class="{ 'has-text-grey': true,'cp-navigation-page-link-item': true }" >
                <b-navbar-item to="/products">
                    <router-link
                      to="/products"
                    >
                      {{ $t('navigation.products') }}
                    </router-link>
                </b-navbar-item>
                <b-navbar-item href="#">
                  Contact
                </b-navbar-item>
            </b-navbar-dropdown> -->
            <b-dropdown :triggers="['hover']" aria-role="list" hoverable>
              <router-link slot="trigger"
                :class="{ 'has-text-white': true, 'cp-navigation-page-link-item': true }"
                to="/products"
                >{{ $t('navigation.products') }}
                  <b-icon pack="fas" icon="caret-down">
                  </b-icon>
              </router-link>
                <b-dropdown-item has-link aria-role="listitem">
                  <router-link slot=""
                    to="/products/byCategories/1">
                  Whitening & Deodorant
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item has-link aria-role="listitem">
                  <router-link slot=""
                    to="/products/byCategories/2"
                  >
                    Extra-Whitening
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item has-link aria-role="listitem">
                  <router-link slot=""
                    to="/products/byCategories/3"
                  >
                    Nano Extra-Whitening + Glutathione
                  </router-link>
                </b-dropdown-item>
              <b-dropdown-item has-link aria-role="listitem">
                <router-link slot=""
                to="/products/byCategories/4"
                >
                  Organic Formula
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item has-link aria-role="listitem">
                <router-link slot=""
                to="/products/byCategories/5"
              >
                  Export only
                </router-link>
              </b-dropdown-item>
            </b-dropdown>
          <!-- <router-link
            :class="{ 'has-text-grey': true, 'cp-navigation-page-link-item': true }"
            to="/articles"
            >{{ $t('navigation.articles') }}</router-link
          > -->
          <router-link
            :class="{ 'has-text-white': true, 'cp-navigation-page-link-item': true }"
            to="/about"
            >{{ $t('navigation.about') }}</router-link
          >
          <router-link
            :class="{ 'has-text-white': true, 'cp-navigation-page-link-item': true }"
            to="/order"
            >Order</router-link
          >
           <!-- <router-link
            :class="{ 'has-text-white': true, 'cp-navigation-page-link-item': true }"
            to="/articles"
            >Blog & News</router-link
          > -->
           <router-link
            :class="{ 'has-text-white': true, 'cp-navigation-page-link-item': true }"
            to="/contact"
            >{{ $t('navigation.contact') }}</router-link
          >
           <!-- <router-link
            to="/order"
            ><div class="md-cart">
              <img src="../assets/img/home/logo-cart.png" class="">
              <span class="md-cart-amount">{{productCart.length}}</span>
            </div>
            </router-link
          > -->
        </div>
      </div>
    </div>
  </fixed-header>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FixedHeader from 'vue-fixed-header';

export default {
  name: 'Navigation',
  components: {
    FixedHeader,
  },
  computed: mapState({
    company: state => state.company,
    contact: state => state.contact,
    productCart: state => state.productCart,
  }),
  methods: {
    updateLocale(locale) {
      this.$store.commit('updateLocale', locale);
    },
    gotoHome() {
      this.$router.push({
        name: 'Home',
        params: {
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.mobile-cart{
  width: 50%;
  float:right;
}
@mixin container {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
 .md-home-logo {
      width: 120px;
  @media screen and (max-width: 768px) {
      width: 100px;
      position: absolute;
      // left: 30%;
      top: 50%;
      transform: translate(0, -50%);
      cursor: pointer;
  }
  }
  .md-home-cart{
     width: 50%;
     float:right;
    @media screen and (max-width: 768px) {
      width: 15%;
      position: absolute;
      left: 80%;
      top: 50%;
      transform: translate(0, -50%);
      cursor: pointer;
    }
  }
@media screen and (min-width: 768px) {
.navbar.vue-fixed-header--isFixed {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
}
}
.md-cart{
  float:right;
  position: relative;
  img{
     width: 40%;
  }
  &-amount{
    background: red;
    color:white;
    border-radius: 100px;
    position: absolute;
    width: 20px;
    height: 20px;
    text-align: center;
  }

}
.bg-black{
  background-color:black !important;

  &::before{
    opacity: .4;
  }
}
.cp-navigation {
  &-header {
    height: $navigationHeaderHeight;

    @media screen and (max-width: 768px) {
      display: block;
      text-align: center;
      p{
        font-size: 8px;
      }
      a{
        width:10%;
      }
    }
  }

  &-header-container {
    @include container;

    height: 100%;
  }

  &-burger {
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;

    @media screen and (min-width: 769px) {
      display: none;
    }
  }

  &-contract {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: white;
  }

  &-telephone {
    margin-right: 8px;
  }

  &-icon {
    margin-right: 5px;
  }

  &-body {
    height: 88px;
    background-color: white;
  }

  &-body-container {
    @include container;

    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    position: relative;

    @media screen and (max-width: 768px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &-page-link {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 900px;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &-page-link-item {
    font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
    &.router-link-active {
       padding: 5px 15px 5px 15px;
      // background-color: $primary;
      background: url("../assets/img/home/button-menu-active.png");
      background-position: center;
      color:black !important;
    }
  }
}
</style>
